var render = function render(){var _vm=this,_c=_vm._self._c;return _c('collection',{attrs:{"accountType":2}})
}
var staticRenderFns = []

export { render, staticRenderFns }